export const SESSION_DATE_CATEGORY = {
  TODAY: 'today',
  THIS_WEEK: 'this-week',
  THIS_YEAR: 'this-year',
  OTHER: 'other',
};

export const VIEW_ENUM = {
  AGENT: 'agent',
  SESSION: 'session',
  MESSAGE: 'message',
};

export const API_URLS_DEFAULT = {
  getModelList: '/aip/api/ai/supported-models',
  getAgentList: '/flow/api/flow-rest/ceta-agent/agent-list',
  getThreadList: '/flow/api/flow-rest/ceta-agent/session/user',
  getMessageList: '/flow/api/flow-rest/ceta-agent/session/users/records',
};

export const AGENT_ABORT_REASON = {
  START_NEW_CHAT: 'start-new-chat',
  REGENERATE: 'regenerate',
};
